import { render, staticRenderFns } from "./ku.vue?vue&type=template&id=3056e888&scoped=true"
import script from "./ku.vue?vue&type=script&lang=js"
export * from "./ku.vue?vue&type=script&lang=js"
import style0 from "./ku.vue?vue&type=style&index=0&id=3056e888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3056e888",
  null
  
)

export default component.exports